
const libPictView = require('pict-view');
const libLogoSlotController = require('../providers/LogoSlotController.js');
const libLabelManagerController = require('../providers/LabelManagerController.js');
const libLabelBehaviorController = require('../providers/LabelBehaviorController.js');

/**
 * MyHeadlight — the configuration landing for the signed-in user's own organization. Sections: Branding
 * (customer primary + reports logos, shared Headlight-LogoSlot template) and Default project labels (the
 * customer's IDProject=0 ProjectTagType set, shared Headlight-LabelManager template). Thin view: state in
 * pict.AppData.MyHeadlight, behavior in the MyHeadlight provider. Built to grow.
 */
class MyHeadlight extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider()
	{
		return this.pict.providers.MyHeadlight;
	}

	onBeforeRender(pRenderable)
	{
		if (this.provider) { this.provider.deriveRenderState(); }
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = MyHeadlight;

module.exports.default_configuration =
{
	ViewIdentifier: 'MyHeadlight',
	DefaultRenderable: 'MyHeadlightWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.mh-wrap { padding: 1.25rem 1.5rem 2rem; max-width: 58rem; }
		.mh-head { margin: 0 0 1.5rem; }
		.mh-eyebrow { font-size: 0.72rem; font-weight: 650; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-text-muted, #6b7686); }
		.mh-title { font-size: 1.55rem; font-weight: 700; line-height: 1.2; margin: 0.1rem 0 0; color: var(--theme-color-text-primary, #1f2733); }
		.mh-subtitle { font-size: 0.9rem; color: var(--theme-color-text-muted, #6b7686); margin: 0.2rem 0 0; }
		.mh-section { margin: 0 0 1.5rem; }
		.mh-section-title { font-size: 0.74rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--theme-color-brand-primary, #5650e6); margin: 0 0 0.6rem; }
		.mh-card { border: 1px solid var(--theme-color-border-default, #d7dce3); border-radius: 10px; background: var(--theme-color-background-panel, #fff); padding: 1.4rem 1.5rem; }
		.mh-help { font-size: 0.85rem; color: var(--theme-color-text-muted, #6b7686); margin: 0 0 0.9rem; line-height: 1.5; }
		.mh-loading { padding: 2.5rem 1rem; }
		${ libLogoSlotController.LOGO_SLOT_CSS }
		${ libLabelManagerController.LABEL_CSS }
		${ libLabelBehaviorController.LABELBEHAVIOR_CSS }
	`,
	Templates:
	[
		{
			Hash: 'MyHeadlight-Wrap',
			Template: /*html*/`
				<div class="mh-wrap">
					{~TS:MyHeadlight-Loading:AppData.MyHeadlight.LoadingSlot~}
					{~TS:MyHeadlight-Body:AppData.MyHeadlight.BodySlot~}
				</div>`
		},
		{
			Hash: 'MyHeadlight-Body',
			Template: /*html*/`
				<div class="mh-head">
					<div class="mh-eyebrow">My Headlight</div>
					<h1 class="mh-title">{~D:AppData.MyHeadlight.CustomerName~}</h1>
					<p class="mh-subtitle">{~D:AppData.MyHeadlight.CustomerLine~}</p>
				</div>
				<div class="mh-section">
					<h2 class="mh-section-title">Branding</h2>
					<div class="mh-card">
						{~TS:Headlight-LogoSlot:AppData.MyHeadlight.LogoSlots~}
					</div>
				</div>
				<div class="mh-section">
					<h2 class="mh-section-title">Default project labels</h2>
					<div class="mh-card">
						<p class="mh-help">Label types every new project starts with (e.g. Contractor, Phase, BidItem). Individual projects can add their own labels on top of these.</p>
						{~TS:Headlight-LabelManager:AppData.MyHeadlight.LabelStateSlot~}
					</div>
				</div>
				<div class="mh-section">
					<h2 class="mh-section-title">Label behavior <span class="pw-label-types-sub" style="font-size:0.85rem;font-weight:400;color:var(--theme-color-text-muted,#6b7686)">— per observation type</span></h2>
					<div class="mh-card">
						<p class="mh-help">How each label behaves during entry, per observation type — <strong>deny free entry</strong> (must pick from the list), a <strong>max per observation</strong>, or <strong>hide</strong> it. <strong>Auto-Filter</strong> narrows each list by the labels already chosen. These are your organization’s defaults; a project can override them on its own Labels tab.</p>
						<div id="MH-LabelBehaviorHost">{~TS:Headlight-LabelBehavior:AppData.MyHeadlight.LabelBehaviorStateSlot~}</div>
					</div>
				</div>`
		},
		{
			Hash: 'MyHeadlight-Loading',
			Template: /*html*/`<div class="mh-loading box has-text-grey has-text-centered"><span class="logo-spin"></span> Loading…</div>`
		},
		...libLogoSlotController.LOGO_SLOT_TEMPLATES,
		...libLabelManagerController.LABEL_TEMPLATES,
		...libLabelBehaviorController.LABELBEHAVIOR_TEMPLATES
	],
	Renderables:
	[
		{
			RenderableHash: 'MyHeadlightWrap',
			TemplateHash: 'MyHeadlight-Wrap',
			ContentDestinationAddress: '#PlatformConfiguration-Application-Container'
		}
	]
};
